import { Grid, Box, Typography } from "@mui/material";
import DelcarMotos from "@/assets/images/DelcarMotos.png";
import Hyundai from "@/assets/images/Hyundai.png";
import Solanas from "@/assets/images/Solanas.png";
import Stiler from "@/assets/images/Stiler.png";
import GrupoFiancar from "@/assets/images/grupoFiancar.png";
import Anep from "@/assets/images/Logos/anep.png";
import Musacco from "@/assets/images/Logos/musacco.png";
import Bastion from "@/assets/images/Logos/Bastion.png";
import Cala from "@/assets/images/Logos/calaDivolpe.png";
import LaAnyta from "@/assets/images/Logos/LaAnyta.png";
import BioKrop from "@/assets/images/Logos/BioKrop.png";
import DLA from "@/assets/images/Logos/DLA.png";
import Aperam from "@/assets/images/Logos/aperam.png";
import Milo from "@/assets/images/Logos/Milo.png";
import SendFex from "@/assets/images/Logos/Senfex.png";
import Ford from "@/assets/images/Logos/pngwing 1.png";
import Rusty from "@/assets/images/Logos/rusty.png";
import Gas from "@/assets/images/Logos/g4s 1.png";
import Misushi from "@/assets/images/Logos/misushi 1.png";
import Nordex from "@/assets/images/Logos/image 34.png";
import Rotunda from "@/assets/images/Logos/image 27.png";
import Saudu from "@/assets/images/Saudu.png";
import Sadia from "@/assets/images/Logos/image 29.png";
import tb from "@/assets/images/Logos/tb 1.png";
import TecnoMax from "@/assets/images/Logos/image 36.png";
import YarTech from "@/assets/images/Logos/yartech 1.png";
import Prontometal from "@/assets/images/Logos/image 35.png";
import lanafil from "@/assets/images/Lanafil1.png";

export const LandingLogos: React.FC = () => {
  const images = [
    { img: DelcarMotos, alt: "DelcarMotos" },
    { img: Hyundai, alt: "Hyundai" },
    { img: Solanas, alt: "Solanas" },
    { img: Stiler, alt: "Stiler" },
    { img: GrupoFiancar, alt: "GrupoFiancar" },
    { img: Anep, alt: "Anep" },
    { img: Musacco, alt: "Musacco" },
    { img: Bastion, alt: "Bastion" },
    { img: Cala, alt: "CalaDivolpe" },
    { img: LaAnyta, alt: "LaAnyta" },
    { img: BioKrop, alt: "BioKrop" },
    { img: DLA, alt: "DLA" },
    { img: Aperam, alt: "Aperam" },
    { img: Milo, alt: "Milo" },
    { img: SendFex, alt: "SendFex" },
    { img: Ford, alt: "Ford" },
    { img: Rusty, alt: "Rusty" },
    { img: Gas, alt: "G4S" },
    { img: Misushi, alt: "Misushi" },
    { img: Nordex, alt: "Nordex" },
    { img: Rotunda, alt: "Rotunda" },
    { img: Saudu, alt: "Saudu" },
    { img: Sadia, alt: "Sadia" },
    { img: tb, alt: "TB" },
    { img: TecnoMax, alt: "TecnoMax" },
    { img: YarTech, alt: "YarTech" },
    { img: Prontometal, alt: "Prontometal" },
    { img: lanafil, alt: "Lanafil" },
  ];

  return (
    <Grid
      container
      component="div"
      sx={{
        width: "100%",
        padding: { xs: "auto", lg: "4rem" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        margin: {
          xs: "auto",
          lg: "1rem",
        },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: "3rem",
          fontWeight: 700,
          color: "#1F6B45",
          margin: "3rem 0",
          textAlign: "center",
        }}
        fontFamily={"Montserrat"}
      >
        Confían en nosotros
      </Typography>
      <Grid
        container
        spacing={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "center",
          width: "100%",
        }}
      >
        {images.map((item, index) => (
          <Grid
            key={index}
            item
            sm={6}
            lg={3}
            xl={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", height: "6rem" }}>
              <Box
                component="img"
                sx={{ width: "8rem" }}
                src={item.img}
                alt={item.alt}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
